/**
 *
 *
 *
 */

export const fixIosFontsize = (): void => {
  const fontSizePropertyName = "font-size";
  if (!window.CSS.supports("(font: -apple-system-body) and (-webkit-touch-callout: default)")) {
    return;
  }

  const divElement = document.createElement("div");
  divElement.setAttribute("style", "font: -apple-system-body");
  document.documentElement.appendChild(divElement);
  /*                                                                 */
  document.documentElement.style.removeProperty(fontSizePropertyName);
  /*                         */
  const fontSize = parseInt(window.getComputedStyle(divElement).fontSize, 10);
  if (fontSize % 2 !== 0) {
    /*                                                    */
    document.documentElement.style.setProperty(
      fontSizePropertyName,
      `${fontSize - 1}px`,
      "important",
    );
  }
  document.documentElement.removeChild(divElement);
};

fixIosFontsize();

/*                                                                                                 */
document.addEventListener("visibilitychange", () => {
  if (document.hidden) return;
  fixIosFontsize();
});
